import { apiRequest } from "../../util/apiRequest";

export const handleGetFormId = async (setFormData, email, documentId) => {
  const { status, message, data } = await apiRequest(
    "/pandadoc/create",
    "post",
    {
      documentId,
      recipient: email,
    }
  );
  if (status) {
    return setFormData({
      formId: data.id,
      available: true,
    });
  }
  return setFormData({
    available: false,
  });
};
